"use strict";
import { addEvent } from "../addEvent/addEvent";
import { isMobile } from "../isMobile/isMobile";
import { ajaxFormClass } from "../form/form";
import { smoothScrollbarInit } from "../smoothScrollbar/smoothScrollbar";
import datepicker from "js-datepicker";

export const showMoreInfo = class {
  moreInfoContainer = false;
  mainContainer = false;

  allClickElementsArray = [];
  infoArray = [];
  showIndex = false;
  infoList = false;

  showFullInfoBodyClass = "show-full-info-enable";
  moreInfoLinkClass = "show-full-info";
  moreInfoTargetContainerClass = "full-info-container";

  moreInfoContainerClass = "show-full-info-container";
  moreInfoContainerAnimationInClass = "show-full-info-container--animation-in";
  moreInfoContainerAnimationOutClass =
    "show-full-info-container--animation-out";
  moreInfoListClass = "show-full-info-container__list";
  containerInfoClass = "show-full-info-container__info-container";
  containerInfoCloseButtonClass = "show-full-info-container__close-button";

  showOneThingClass = "more-info-list--show-only-one";
  showOneThingListClass = "show-full-info-container__list--show-only-one";
  showOneThing = false;

  animationInTime = 1000;
  animationOutTime = 800;

  constructor(config = {}) {
    if (!config.mainContainer) return false;
    this.mainContainer = config.mainContainer;

    this._init();
    return this;
  }

  _init = () => {
    const {
      mainContainer,
      moreInfoLinkClass,
      showOneThingClass,
      _addClickToElement,
      _initShow,
    } = this;
    const elements = mainContainer.getElementsByTagName("A");
    this.showOneThing = true;
    if (mainContainer.classList.contains(showOneThingClass)) {
      this.showOneThing = true;
    }

    document.addEventListener("click", (e) => {
      // Sprawdzenie, czy kliknięty element to <a> z kotwicą "#formularz"
      const clickElement = e.target.closest('a[href^="#"]');

      if (
        clickElement &&
        (clickElement.getAttribute("href").trim() === "#formularz" ||
          clickElement.getAttribute("href").trim() === "#wolontariat")
      ) {
        e.preventDefault(); // Zapobiegaj domyślnej akcji przeglądarki
        _initShow(clickElement); // Twoja funkcja do obsługi kliknięcia
      }
    });

    // Array.from(elements).forEach((elm) => {
    //   console.log(elm.hash);
    //   if (elm.tagName === "A" && elm.hash == "#formularz") {
    //     this.allClickElementsArray.push(elm);
    //     _addClickToElement(elm);
    //   }
    // });
  };

  _addClickToElement = (clickElement) => {
    const { _initShow } = this;

    if (
      clickElement.hash != "#formularz" &&
      clickElement.hash != "#wolontariat"
    )
      return;
    addEvent(clickElement, "click", (e) => {
      e.preventDefault();
      _initShow(clickElement);
    });
  };

  _initShow = (clickElement) => {
    const {
      mainContainer,
      moreInfoTargetContainerClass,
      containerInfoClass,
      _getAnchor,
      _createLayout,
    } = this;

    const infoId = clickElement.href;
    const infos = mainContainer.getElementsByClassName(
      moreInfoTargetContainerClass
    );

    Array.from(infos).forEach((elm) => {
      let newElm = elm.cloneNode(true);
      newElm.classList.remove(moreInfoTargetContainerClass);
      newElm.classList.add(containerInfoClass);
      this.infoArray.push(newElm);
    });

    Array.from(this.infoArray).forEach((elm, idx) => {
      if (_getAnchor(clickElement.href) === elm.id) {
        this.showIndex = idx;
      }
    });

    _createLayout();
  };

  _createLayout = () => {
    const {
      mainContainer,
      moreInfoContainerClass,
      containerInfoCloseButtonClass,
      moreInfoListClass,
      moreInfoContainerAnimationInClass,
      containerInfoClass,
      showFullInfoBodyClass,
      infoArray,
      showOneThing,
      showOneThingListClass,
      _closeInfo,
      _keyFunctions,
      _formInit,
    } = this;
    const body = document.body;

    let layoutContainer = body.getElementsByClassName(moreInfoContainerClass);
    Array.from(layoutContainer).forEach((elm) => {
      elm.remove();
    });

    this.moreInfoContainer = document.createElement("div");
    this.moreInfoContainer.classList.add(moreInfoContainerClass);

    let buttonClose = document.createElement("a");
    buttonClose.href = "#";
    buttonClose.title = "Close";
    buttonClose.classList.add(containerInfoCloseButtonClass);
    let buttonCloseSpan = document.createElement("span");
    buttonClose.appendChild(buttonCloseSpan);
    buttonCloseSpan = document.createElement("span");
    buttonClose.appendChild(buttonCloseSpan);
    addEvent(buttonClose, "click", (e) => {
      e.preventDefault();
      if (this.moreInfoContainer) {
        _closeInfo();
      }
    });

    this.moreInfoContainer.appendChild(buttonClose);

    this.infoList = document.createElement("ul");
    this.infoList.classList.add(moreInfoListClass);
    if (showOneThing) this.infoList.classList.add(showOneThingListClass);

    let data_more_info_class = mainContainer.dataset.moreinfospecialclass;
    if (data_more_info_class != "" && data_more_info_class != undefined) {
      this.moreInfoContainer.classList.add(data_more_info_class);
    }

    let scrollOnstartTo = false;

    infoArray.forEach((elm, idx) => {
      let li = document.createElement("li");
      elm.removeAttribute("id");
      li.appendChild(elm);

      if (showOneThing) {
        if (this.showIndex == idx) this.infoList.appendChild(li);
      } else {
        this.infoList.appendChild(li);
        if (this.showIndex && this.showIndex == idx) {
          scrollOnstartTo = li;
        }
      }
    });

    this.moreInfoContainer.appendChild(this.infoList);

    body.classList.add(showFullInfoBodyClass);
    body.appendChild(this.moreInfoContainer);

    if (!isMobile())
      this.moreInfoContainer.smoothScroll = smoothScrollbarInit(
        {
          damping: 0.1,
        },
        ".show-full-info-container__list"
      );

    setTimeout(() => {
      this.moreInfoContainer.classList.add(moreInfoContainerAnimationInClass);
      this.infoList.scrollTop = scrollOnstartTo ? scrollOnstartTo.offsetTop : 0;
      _keyFunctions();
      _formInit();
    }, 10);
  };

  _formInit = () => {
    const { moreInfoContainer, _data_picker } = this;

    let ajaxForms = $(moreInfoContainer).find(".ajax-form");

    ajaxForms.each((idx, form) => {
      new ajaxFormClass(form);
      _data_picker();
    });
  };

  _data_picker = () => {
    const { moreInfoContainer } = this;

    let dateElements = $(moreInfoContainer).find(".data-picker");

    dateElements.each((idx, elm) => {
      datepicker(elm, {
        startDay: 1,
        overlayPlaceholder: "Wpisz rok w postaci: rrrr",
        overlayButton: "zatwierdź",
        formatter: (input, date, instance) => {
          let month = "" + (date.getMonth() + 1);
          let day = "" + date.getDate();
          let year = date.getFullYear();

          if (month.length < 2) month = "0" + month;
          if (day.length < 2) day = "0" + day;

          input.value = year + "-" + month + "-" + day;

          //const value = date.toLocaleDateString();
          //input.value = value;
        },
        customDays: ["N", "Po", "Wt", "Śr", "Cz", "Pt", "So"],
        customMonths: [
          "Styczeń",
          "Luty",
          "Marzec",
          "Kwiecień",
          "Maj",
          "Czerwiec",
          "Lipiec",
          "Sierpien",
          "Wrzesień",
          "Pażdziernik",
          "Listopad",
          "Grudzień",
        ],
      });
    });
  };

  _getAnchor = (href) => {
    const urlParts = href.split("#");
    return urlParts.length > 1 ? urlParts[1] : null;
  };

  _keyFunctions = () => {
    addEvent(document, "keyup", this._keyUpFunction);
  };

  _keyUpFunction = (e) => {
    const { _closeInfo } = this;

    if (e.keyCode === 27 && this.mainContainer) {
      _closeInfo();
    }
  };

  _closeInfo = () => {
    const {
      moreInfoContainer,
      animationOutTime,
      moreInfoContainerAnimationInClass,
      moreInfoContainerAnimationOutClass,
      showFullInfoBodyClass,
    } = this;
    const body = document.body;

    moreInfoContainer.classList.remove(moreInfoContainerAnimationInClass);
    moreInfoContainer.classList.add(moreInfoContainerAnimationOutClass);

    setTimeout(() => {
      this.moreInfoContainer.remove();
      this.moreInfoContainer = false;
      this.allClickElementsArray = [];
      this.infoArray = [];
      this.showIndex = false;
      this.infoList = false;
      body.classList.remove(showFullInfoBodyClass);
      document.addEventListener("keyup", this._keyUpFunction, false);
    }, animationOutTime);
  };
};
